
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/python-essentials-data-science",
      function () {
        return require("private-next-pages/python-essentials-data-science.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/python-essentials-data-science"])
      });
    }
  